module.exports = __webpack_public_path__ + "img/005.5319645f.jpg";